import { EColorButton } from 'enums'
import { EExamStatus } from 'pages/patientBooking/enums'

export const CFilterExam = {
  Waiting: {
    label: 'waiting-examination',
    value: EExamStatus.Waiting,
    color: EColorButton.YellowTrace
  },
  InProgress: {
    label: 'being-examined',
    value: EExamStatus.InProgress,
    color: EColorButton.BlueTrace
  },
  DataCollection: {
    label: 'data-collection',
    value: EExamStatus.DataCollection,
    color: EColorButton.CyanTrace
  },
  Finished: {
    label: 'examed',
    value: EExamStatus.Finished,
    color: EColorButton.GreenTrace
  },
  Cancel: {
    label: EExamStatus.Canceled,
    value: EExamStatus.Canceled,
    color: EColorButton.RedTrace
  }
}
